<template>
  <div class="brand-logo" :class="{
      'brand-logo--light': light,
      'brand-logo--large': large,
    }">LEAGUEPOINTS<span>.</span></div>
</template>

<script>
export default {
  props: {
    light: {
      type: Boolean,
    },
    large: {
      type: Boolean,
    },
  },
}
</script>

<style lang="sass">
@import '../sass/variables'
@import '~bulma/sass/utilities/variables'

.brand-logo
  font-size: 1.5rem
  font-weight: 500
  color: $text

  &--light
    color: white

  &--large
    font-size: 2.5rem
    font-weight: 700

  span
    color: $primary

.is-dark
  .brand-logo:not(.brand-logo--light)
    color: rgba(white, 0.95)
</style>



// WEBPACK FOOTER //
// BrandLogo.vue?78382e29